import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VisaApplicationService {
  private apiUrl = `${environment.apiUrl}/visaApplication`;
  constructor(private http: HttpClient) {}

  getByGuid(visaApplicationId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${visaApplicationId}`);
  }
}
